import { render, staticRenderFns } from "./PlayerOpenings.vue?vue&type=template&id=4f9824f5"
import script from "./PlayerOpenings.vue?vue&type=script&lang=js"
export * from "./PlayerOpenings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports